var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "occupation-edit-wrapper" }, [
    _c(
      "form",
      {
        attrs: { autocomplete: "off", method: "post", "data-vv-scope": "form" },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return (() => {
              return false
            }).apply(null, arguments)
          },
          submit: function ($event) {
            $event.preventDefault()
            return (() => {
              return false
            }).apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-sm-6 col-lg-5" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("cemetery_id", {
                          required: true,
                        }),
                        expression:
                          "rulesField('cemetery_id', { required: true })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: !!_vm.form.id,
                      id: "input-cemetery",
                      name: "cemetery",
                      label: "name",
                      options: _vm.cemeteries,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError("cemetery", _vm.vScope),
                        },
                      ],
                      error: _vm.fnFirstError("cemetery", _vm.vScope),
                    },
                    model: {
                      value: _vm.cemeteryId,
                      callback: function ($$v) {
                        _vm.cemeteryId =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "cemeteryId",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.cemetery`)) +
                        "\n\t\t\t\t\t"
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-6 col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("sector_id", { required: true }),
                        expression:
                          "rulesField('sector_id', { required: true })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.readonlyForm,
                      id: "input-sector",
                      name: "sector",
                      label: "number",
                      initialData: _vm.form.sector,
                      options: _vm.sectors,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("sector", _vm.vScope) },
                      ],
                      error: _vm.fnFirstError("sector", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.sector_id,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "sector_id",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.sector_id",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.sector`)) +
                        "\n\t\t\t\t\t"
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-6 col-lg-2" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("row"),
                        expression: "rulesField('row')",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-row",
                      name: "row",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("row", _vm.vScope) },
                      ],
                      error: _vm.fnFirstError("row", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.row,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "row",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.row",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.row`)) +
                        "\n\t\t\t\t\t"
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-6 col-lg-2" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesField("number", { required: true }),
                        expression: "rulesField('number', { required: true })",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: "input-number",
                      name: "number",
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("number", _vm.vScope) },
                      ],
                      error: _vm.fnFirstError("number", _vm.vScope),
                    },
                    model: {
                      value: _vm.form.number,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "number",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.number",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t(`${_vm.modelTranslateID}.number`)) +
                        "\n\t\t\t\t\t"
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row details_adding" }, [
          _c("div", { staticClass: "col-12 col-sm edit-occupation-details" }, [
            _c("div", { staticClass: "edit-occupation-form" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("occupation_type_id", {
                                required: true,
                              }),
                              expression:
                                "rulesField('occupation_type_id', { required: true })",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyForm,
                            id: "input-occupation_type",
                            name: "occupation_type",
                            label: "name",
                            options: _vm.types,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "occupation_type",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "occupation_type",
                              _vm.vScope
                            ),
                          },
                          model: {
                            value: _vm.form.occupation_type_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "occupation_type_id",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.occupation_type_id",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.modelTranslateID}.occupation_type`
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("occupation_state_type_id"),
                              expression:
                                "rulesField('occupation_state_type_id')",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyForm,
                            id: "input-occupation_state_type",
                            name: "occupation_state_type",
                            label: "name",
                            options: _vm.states,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "occupation_state_type",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "occupation_state_type",
                              _vm.vScope
                            ),
                          },
                          model: {
                            value: _vm.form.occupation_state_type_id,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "occupation_state_type_id",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.occupation_state_type_id",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.modelTranslateID}.occupation_state_type`
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("burials_capacity", {
                                required: true,
                                integer: true,
                                min_value: 0,
                              }),
                              expression:
                                "rulesField('burials_capacity', { required: true, integer: true, min_value: 0 })",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: _vm.readonlyForm,
                            disabled: _vm.readonlyForm,
                            type: "number",
                            id: "input-burials_capacity",
                            name: "burials_capacity",
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "burials_capacity",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "burials_capacity",
                              _vm.vScope
                            ),
                          },
                          model: {
                            value: _vm.form.burials_capacity,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "burials_capacity",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.burials_capacity",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.modelTranslateID}.burials_capacity`
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("entombment_capacity", {
                                required: true,
                                integer: true,
                                min_value: 0,
                              }),
                              expression:
                                "rulesField('entombment_capacity', { required: true, integer: true, min_value: 0 })",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: _vm.readonlyForm,
                            disabled: _vm.readonlyForm,
                            type: "number",
                            id: "input-entombment_capacity",
                            name: "entombment_capacity",
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "entombment_capacity",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "entombment_capacity",
                              _vm.vScope
                            ),
                          },
                          model: {
                            value: _vm.form.entombment_capacity,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "entombment_capacity",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.entombment_capacity",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.modelTranslateID}.entombment_capacity`
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("cremation_capacity", {
                                required: true,
                                integer: true,
                                min_value: 0,
                              }),
                              expression:
                                "rulesField('cremation_capacity', { required: true, integer: true, min_value: 0 })",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: _vm.readonlyForm,
                            disabled: _vm.readonlyForm,
                            type: "number",
                            id: "input-cremation_capacity",
                            name: "cremation_capacity",
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "cremation_capacity",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "cremation_capacity",
                              _vm.vScope
                            ),
                          },
                          model: {
                            value: _vm.form.cremation_capacity,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "cremation_capacity",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.cremation_capacity",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.modelTranslateID}.cremation_capacity`
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("total_capacity", {
                                required: true,
                                integer: true,
                                min_value: 0,
                              }),
                              expression:
                                "rulesField('total_capacity', { required: true, integer: true, min_value: 0 })",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: true,
                            disabled: true,
                            type: "number",
                            id: "input-total_capacity",
                            name: "total_capacity",
                            value: _vm.form.total_capacity,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  "total_capacity",
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(
                              "total_capacity",
                              _vm.vScope
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(`${_vm.modelTranslateID}.total_capacity`)
                              ) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-sm-6 city-form-group upload-image",
                      },
                      [
                        _c("UploadMultipleImage", {
                          attrs: {
                            disabled: _vm.readonlyForm,
                            maxImage: _vm.maxImages,
                            enableMainImage: _vm.enableMainImage,
                            imageSize: _vm.imageSize,
                            imagesPerRow: _vm.imagesPerRow,
                            direction: _vm.imageDirection,
                            noSpaceBetween: true,
                            heightAuto: false,
                            pathProperty: "url",
                            filenameProperty: "filename",
                            extraNewProperties: _vm.newImageProperties,
                            imageClass: "background-contain",
                          },
                          model: {
                            value: _vm.form.images,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "images", $$v)
                            },
                            expression: "form.images",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-sm-6" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "MaterialSelect",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rulesField(
                                        "occupation_direction_type_id"
                                      ),
                                      expression:
                                        "rulesField('occupation_direction_type_id')",
                                    },
                                  ],
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    disabled: _vm.readonlyForm,
                                    id: "input-occupation_direction_type",
                                    name: "occupation_direction_type",
                                    label: "name",
                                    options: _vm.directions,
                                    "data-vv-scope": _vm.vScope,
                                    inputClasses: [
                                      {
                                        "is-invalid": _vm.fnHasError(
                                          "occupation_direction_type",
                                          _vm.vScope
                                        ),
                                      },
                                    ],
                                    error: _vm.fnFirstError(
                                      "occupation_direction_type",
                                      _vm.vScope
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.form.occupation_direction_type_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "occupation_direction_type_id",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression:
                                      "form.occupation_direction_type_id",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          `${_vm.modelTranslateID}.occupation_direction_type`
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "MaterialSelect",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rulesField(
                                        "occupation_position_type_id"
                                      ),
                                      expression:
                                        "rulesField('occupation_position_type_id')",
                                    },
                                  ],
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    disabled: _vm.readonlyForm,
                                    id: "input-occupation_position_type",
                                    name: "occupation_position_type",
                                    label: "name",
                                    options: _vm.positions,
                                    "data-vv-scope": _vm.vScope,
                                    inputClasses: [
                                      {
                                        "is-invalid": _vm.fnHasError(
                                          "occupation_position_type",
                                          _vm.vScope
                                        ),
                                      },
                                    ],
                                    error: _vm.fnFirstError(
                                      "occupation_position_type",
                                      _vm.vScope
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.occupation_position_type_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "occupation_position_type_id",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression:
                                      "form.occupation_position_type_id",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          `${_vm.modelTranslateID}.occupation_position_type`
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "MaterialInput",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rulesField("price", {
                                        required: true,
                                        decimal: _vm.priceDecimalPlaces,
                                        min_value: 0,
                                      }),
                                      expression:
                                        "rulesField('price', { required: true, decimal: priceDecimalPlaces, min_value: 0 })",
                                    },
                                  ],
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    readonly: _vm.readonlyForm,
                                    disabled: _vm.readonlyForm,
                                    type: "number",
                                    id: "input-price",
                                    name: "price",
                                    step: _vm.stepPriceDecimalPlaces,
                                    "data-vv-scope": _vm.vScope,
                                    inputClasses: [
                                      {
                                        "is-invalid": _vm.fnHasError(
                                          "price",
                                          _vm.vScope
                                        ),
                                      },
                                    ],
                                    error: _vm.fnFirstError(
                                      "price",
                                      _vm.vScope
                                    ),
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "grpAppend",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.currency.symbol)
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.form.price,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "price",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "form.price",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(`${_vm.modelTranslateID}.price`)
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-12 align-self-center form-group",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-check city-form-check form-check-inline",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.form.show_price,
                                      expression: "form.show_price",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    readonly: _vm.readonlyForm,
                                    disabled: _vm.readonlyForm,
                                    type: "checkbox",
                                    id: "input-show_price",
                                    name: "show_price",
                                    "false-value": false,
                                    "true-value": true,
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.form.show_price)
                                      ? _vm._i(_vm.form.show_price, null) > -1
                                      : _vm.form.show_price,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.form.show_price,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.form,
                                              "show_price",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              "show_price",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.form, "show_price", $$c)
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label h-auto",
                                    attrs: { for: `input-show_price` },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-column align-items-start",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  `${_vm.modelTranslateID}.show_price`
                                                )
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialTextarea",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("inscription"),
                              expression: "rulesField('inscription')",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: _vm.readonlyForm,
                            disabled: _vm.readonlyForm,
                            id: `input-inscription`,
                            name: `inscription`,
                            rows: 1,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(
                                  `inscription`,
                                  _vm.vScope
                                ),
                              },
                            ],
                            error: _vm.fnFirstError(`inscription`, _vm.vScope),
                          },
                          model: {
                            value: _vm.form.inscription,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "inscription",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.inscription",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(`${_vm.modelTranslateID}.inscription`)
                              ) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialTextarea",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rulesField("obs"),
                              expression: "rulesField('obs')",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: _vm.readonlyForm,
                            disabled: _vm.readonlyForm,
                            id: `input-obs`,
                            name: `obs`,
                            rows: 3,
                            "data-vv-scope": _vm.vScope,
                            inputClasses: [
                              {
                                "is-invalid": _vm.fnHasError(`obs`, _vm.vScope),
                              },
                            ],
                            error: _vm.fnFirstError(`obs`, _vm.vScope),
                          },
                          model: {
                            value: _vm.form.obs,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "obs",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.obs",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t(`${_vm.modelTranslateID}.obs`)) +
                              "\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-12" },
                  [
                    _c("OccupationFiles", {
                      attrs: {
                        panelCfg: _vm.panelCfg,
                        vScope: _vm.vScope,
                        readonlyForm: _vm.readonlyForm,
                        baseTranslateID: _vm.baseTranslateID,
                      },
                      model: {
                        value: _vm.form.files,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "files", $$v)
                        },
                        expression: "form.files",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-sm-4 adding-interment_deed_owners" },
            [
              _c(
                "div",
                { staticClass: "deed_owners" },
                [
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(`${_vm.modelTranslateID}.deed_owner.titles`)
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.allowAddDeedOwner
                    ? _c("PlusItem", { on: { add: _vm.onAddDeedOwner } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.deed_owners, function (item, idx) {
                    return _c(
                      "div",
                      {
                        key: `deed_owner-item-${idx}`,
                        staticClass: "deed_owner-item",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onViewDetailDeedOwner(item)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "holders-names" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (item.names ?? []).length
                                  ? (item.names ?? []).join(", ")
                                  : "[SEM TITULAR]"
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "application-date" }, [
                          item.occupation_right_type
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(item.occupation_right_type?.name) +
                                    " "
                                ),
                                _c("span", [_vm._v("|")]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.occupation_term_right_type
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.occupation_term_right_type?.name
                                    ) +
                                    " "
                                ),
                                _c("span", [_vm._v("|")]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatDateToDisplay(item.application_at)
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "interments" },
                [
                  _c("div", { staticClass: "title_adding" }, [
                    _c("h4", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(`${_vm.modelTranslateID}.interment.titles`)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.allowAddInterment
                    ? _c("PlusItem", { on: { add: _vm.onAddDeedInterment } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.interments, function (item, idx) {
                    return _c(
                      "div",
                      {
                        key: `occupation-interment-item-${idx}`,
                        staticClass: "interment-item",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onViewDetailInterment(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "interment-name" }, [
                          _c("span", {}, [_vm._v(_vm._s(item?.entity?.name))]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "interment-birth_death_age" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.formatDateToDisplay(
                                  item?.entity?.birth_at ?? "n/a"
                                )
                              ) +
                              " - " +
                              _vm._s(
                                _vm.formatDateToDisplay(
                                  item?.entity?.death_at ?? "n/a"
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", {}, [
                            _vm._v(
                              "(" +
                                _vm._s(item?.entity?.age ?? "n/a") +
                                " " +
                                _vm._s(
                                  _vm
                                    .$t(
                                      `${_vm.modelTranslateID}.interment.years`
                                    )
                                    .toLowerCase()
                                ) +
                                ")"
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }